export default function CreateRumbleIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' fill='none'>
      <path
        d='M14.25 9.75h-4.5v4.5h-1.5v-4.5h-4.5v-1.5h4.5v-4.5h1.5v4.5h4.5v1.5Z'
        fill='#fff'
      />
    </svg>
  );
}
